import { Component, EventEmitter, Output } from '@angular/core';
import { CurrencyViewService } from 'src/app/core/services/general/currency-view.service';

/**
 * THE CURRENCY THE SCREEN IS IN — the control beside the date filter on a dashboard.
 *
 * Tatenda, 2026-10-06: *"when you choose ZIG… everything on the dashboard turns into ZiG. It's the
 * default picker, what you see from that moment is ZiG."*
 *
 * ── It is a FILTER, not a conversion ─────────────────────────────────────────────────────────
 * This system holds no exchange rate — a ZIMRA constraint, not a limitation — so nothing here
 * converts anything. The books already exist side by side; this chooses which one is on screen. That
 * is why it sits beside "All time": both answer "which slice of the truth am I looking at".
 *
 * ── It renders nothing while there is one book ───────────────────────────────────────────────
 * Which is every tenant until ZiG is switched on. The same rule every other currency surface in this
 * UI follows: no switch, no extra control, nothing new for an operator to understand.
 */
@Component({
  selector: 'app-currency-view-choice',
  templateUrl: './currency-view-choice.component.html',
  styleUrls: ['./currency-view-choice.component.scss'],
})
export class CurrencyViewChoiceComponent {
  /** Raised after the book changes, so the dashboard can reload its figures. */
  @Output() changed = new EventEmitter<string>();

  public open = false;

  constructor(public currencyView: CurrencyViewService) {}

  get asks(): boolean {
    return this.currencyView.asks;
  }

  get book(): string {
    return this.currencyView.book;
  }

  get choices(): Array<string> {
    return this.currencyView.choices;
  }

  get isBase(): boolean {
    return this.currencyView.isBase;
  }

  toggle(): void {
    this.open = !this.open;
  }

  choose(code: string): void {
    this.open = false;
    if (code === this.book) {
      return;
    }

    this.currencyView.choose(code);
    this.changed.emit(this.currencyView.book);
  }

  isPicked(code: string): boolean {
    return code.trim().toUpperCase() === this.book.trim().toUpperCase();
  }
}
